<!-- src/components/Applications/AfsalSereign/AfsalUmsokn.vue -->
<script setup lang="ts">
import ApplicationBase from '@/components/Applications/ApplicationBase.vue'

// Steps / shared components
import Umsaekjandi from '@/components/Applications/Shared/Umsaekjandi.vue'
import Step2 from './Steps/Step2.vue'
import Step3 from './Steps/Step3.vue'
import Step4 from './Steps/Step4.vue'
import Step5 from './Steps/Step5.vue'
import Step6 from './Steps/Step6.vue'
import Undirritun from '@/components/Applications/Shared/Undirritun.vue'
import BeginStep from './Steps/Afsal_begin.vue'
// import LokaSkref from '@/components/Applications/Shared/LokaSkref.vue'

// App identity for Afsal Séreignar
const APP_ID = 6
// Use a stable key for incremental saves in your backend
const UPDATE_KEY = 'afsal-sereign'

// If you need to kick off Signet doc creation when Undirritun mounts,
// you can pass a small hook via props to that component (if supported in your codebase).
// For now we keep it simple and let <Undirritun> handle its own lifecycle as before.

const steps = [
  // 1
    { comp: BeginStep, titleKey: '' },
  { comp: Umsaekjandi, titleKey: 'umsokn_umsaekjandi_header' },

  // 2..6 — straight-through steps
  { comp: Step2, titleKey: 'umsokn_afsal_sereign_step2_header1' },
  { comp: Step3, titleKey: 'umsokn_afsal_sereign_step3_header1' },
  { comp: Step4, titleKey: 'umsokn_afsal_sereign_step4_header1' },
  { comp: Step5, titleKey: 'umsokn_afsal_sereign_step5_header1' },
  { comp: Step6, titleKey: 'umsokn_samantekt_header' },

  // 7 — Undirritun (signature)
  // If your Shared/Undirritun expects props (e.g., signet type),
  // you can pass them via `props` below. Example: { signetType: 6 }
  { comp: Undirritun, titleKey: 'undirritun_umsokn_header1', props: { /* signetType: 6 */ } },

  // 8 — Done
//   { comp: LokaSkref, titleKey: 'umsokn_afsal_sereign_done_header' },
]
</script>

<template>
    <!-- ApplicationBase handles: create/fetch app, step state, prev/next, autosave via update-key -->
    <ApplicationBase
      :app-id="APP_ID"
      :update-key="UPDATE_KEY"
      :steps="steps"
    />
</template>

<style scoped lang="scss">
.forms__transition__header { top: 0; }
</style>
